module.exports = {"id":"208008","name":"Vitinho","rating":"77","photo":"./data/images/photos/4/208008.png","club":{"name":"CSKA Moscou","logo":"./data/images/clubs/CSKAMoscou.png"},"positions":["BU","MOC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Vitinho0.json
// module id = 4288
// module chunks = 0